var _rect, _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "YouTube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    ry: 6,
    fill: "#f00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12s0-2.6-.33-3.85c-.18-.69-.72-1.23-1.41-1.41-1.25-.33-6.25-.33-6.25-.33s-5 0-6.25.33c-.69.18-1.23.73-1.41 1.41C4.02 9.4 4.02 12 4.02 12s0 2.6.33 3.85c.18.69.73 1.23 1.41 1.41 1.25.33 6.25.33 6.25.33s5 0 6.25-.33c.69-.18 1.23-.72 1.41-1.41C20 14.6 20 12 20 12Z",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "14.56 12 10.4 9.6 10.4 14.4 14.56 12",
    fill: "#f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social-youtube.88fc5448aeb31531fd8882cd8c14d47c.svg";
export { ForwardRef as ReactComponent };